import React,{useState,useEffect} from 'react'
import {Box, DataTable,Button } from 'grommet'
import { withRouter } from 'react-router-dom';
import { Add } from 'grommet-icons';
import { TableLoadLayer, NavigationSnackBar } from '../../../components/utils/shared/shared';
import {APIRequest} from '../../../components/utils/shared/requests'
import {ShipmentSuccessNotification} from '../../../components/utils/shared/shipmentViewFunctions'

function LabList (props) {
  const [labs, setLabs] = useState([]);
  const [labSucc, setLabSucc] = useState(props.location.labSucc)
  const [load, setLoad] = useState(true)
  useEffect(() => {     
    APIRequest('/labs').then(result => {setLabs(result); setLoad(false)})
    setTimeout(() => {
      setLabSucc(undefined);
    }, 5000)
   },[]);
  return (
   <Box wrap flex="grow">
      <NavigationSnackBar title={'Labs'} user={props.user} pages={[{name: 'Dashboard', link: '/dashboard'}]}  />
      {labSucc && (<ShipmentSuccessNotification label={"Lab"} edit={props.location.edit} />)}
     <Box direction='row' justify='end'>
        <Button primary label='Create Lab' margin='small' icon={<Add />} hoverIndicator onClick={() => props.history.push('/admin/labs/new')}/>
      </Box>
      <Box margin='medium' pad='small' elevation="medium" overflow='scroll' round>
       
      <DataTable background={{ header: { color: '#18445C'}, footer: { color: 'dark-3', opacity: 'strong' }}} paginate step={10} pad={{ horizontal: 'xsmall', vertical: 'small' }} margin='xsmall' columns={[ {header:"ID",property:"id",primary:true,sortable:true,search:false}, {header:"Name",property:"name", search:true}, {header:"Country",property:"address.Country.CountryName",sortable:true,search:false}, {header:"Organization",property:"organisation.name",sortable:true,search:true}, ]}  onClickRow={({datum}) => {props.history.push({pathname:`/admin/labs/edit/${datum.id}`})}} data={labs} />
      {load && (<TableLoadLayer load={load} label={"Loading Labs..."} />)}
        </Box>
   </Box>
  )
}

export default withRouter(LabList)
